let uuidv4 = require('uuid/v4');

export default class Notification {
	static get TYPE() {
		const type = {
			INFO: 'info',
			ERROR: 'error',
		};
		return type;
	}

	constructor(type, message, uniq_type) {
		this.id = uuidv4();
		this.type = type;
		this.message = message; 
		if (uniq_type !== undefined){
			this.uniq_type = uniq_type;
		}else{
			this.uniq_type = null;
		}
		this.state = {
			timeout: 3000,
			count: 1,
		};
	}

	static info(message, uniq_type) {
		return new Notification(Notification.TYPE.INFO, message, uniq_type);
	}

	static error(message, uniq_type) {
		return new Notification(Notification.TYPE.ERROR, message, uniq_type);
	}

	timeout(timeout) {
		this.state.timeout = timeout;
		return this;
	}

	notimeout(){
		return this.timeout(0);
	}
}
